import { Button, Input } from "../../../Components/ui";

export function ListPagination({ page, count, pageSize = 20, loading, onChange, label }: {
  page: number; count: number; pageSize?: number; loading: boolean; onChange: (page: number) => void; label: string;
}) {
  const pages = Math.max(1, Math.ceil(count / pageSize));
  return <nav aria-label={`${label} 페이지`} className="d-flex flex-wrap align-items-center justify-content-end gap-2 mt-3">
    <span className="text-muted small">총 {count}건 · {page} / {pages} 페이지</span>
    <Button size="sm" color="light" disabled={loading || page <= 1} onClick={() => onChange(page - 1)}>이전</Button>
    <Button size="sm" color="light" disabled={loading || page >= pages} onClick={() => onChange(page + 1)}>다음</Button>
  </nav>;
}

export function ListDateFilters({ from, to, onChange }: { from: string; to: string; onChange: (from: string, to: string) => void }) {
  return <>
    <Input aria-label="시작일" type="date" value={from} onChange={(event) => onChange(event.target.value, to)} style={{ maxWidth: 170 }} />
    <Input aria-label="종료일" type="date" value={to} min={from || undefined} onChange={(event) => onChange(from, event.target.value)} style={{ maxWidth: 170 }} />
  </>;
}
